const isFunnelReadyToExecute = (selectedFunnel, updatingFunnel) =>
  selectedFunnel.steps.filter((i) => i.enabled).every((i) => !!i.event) &&
  !selectedFunnel.steps.every((i) => !i.enabled) &&
  !updatingFunnel;

export default isFunnelReadyToExecute;
